import {
  EntityList,
  EntityListProps,
  renderPersona,
  renderTimeAgo,
} from 'components/EntityList'
import { DangerousGood } from 'gql.generated'
import {
  ConstrainMode,
  PersonaSize,
  SelectionMode,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type DangerousGoodsListProps = EntityListProps<DangerousGood>

export const DangerousGoodsList: React.FunctionComponent<
  DangerousGoodsListProps
> = ({ items, ...props }) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('unNumber', {
        minWidth: 85,
        ungroupable: true,
        isSorted: true,
      }),
      fieldColumn('description', {
        minWidth: 85,
        ungroupable: true,
        isSorted: true,
      }),
      fieldColumn('modifiedBy', {
        onRender: renderPersona({
          size: PersonaSize.size8,
        }),
        minWidth: 155,
        ungroupable: true,
      }),
      fieldColumn('modified', {
        onRender: renderTimeAgo,
        ungroupable: true,
      }),
    ],
    [fieldColumn]
  )

  return (
    <EntityList
      stickyHeader={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      onShouldVirtualize={() => true}
      {...props}
    />
  )
}
